export default __webpack_public_path__ + "assets/cbad133b94b5057b842dea66b10b43f2.png";